export const SmartProposalStatus = {
  REQUEST: 'SMART_PROPOSAL_REQUEST',
  SUCCESS: 'SMART_PROPOSAL_SUCCESS',
  ERROR: 'SMART_PROPOSAL_ERROR',
  RESET: 'SMART_PROPOSAL_RESET',
};
